import React from 'react'
import './drag.scss'

import StepProgress from 'components/scrollable/StepProgress'
import DragAndDropGame from './DragAndDropGame'
import useEmblaCarousel from 'embla-carousel-react'
import analytics from 'global/AnalyticsData'

const DragDropGame = ({
  breakId,
  step,
  skipButton,
  nextStepButton,
  onEngage = function () {},
  onAwardPoints = function () {},
  isEditorial,
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    watchDrag: false,
  })

  const onStepFinished = () => {
    // TODO: add analytics here
    onEngage()
    onAwardPoints()
    analytics.stepEvent('step_interaction_std_result', step)
  }

  return (
    <>
      <div className="drag_drop_container">
        <StepProgress emblaRef={emblaRef} emblaApi={emblaApi}>
          <DragAndDropGame
            breakId={breakId}
            step={step}
            skipButton={skipButton}
            onSubmitMatches={onStepFinished}
            isEditorial={isEditorial}
          />
        </StepProgress>
        {nextStepButton}
      </div>
    </>
  )
}

export default DragDropGame
